
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M19.9999 21C18.7099 21 17.4199 20.59 16.2599 19.86C16.0999 19.76 15.8899 19.76 15.7299 19.86C13.4199 21.33 10.5699 21.33 8.25989 19.86C8.09989 19.76 7.88989 19.76 7.72989 19.86C6.57989 20.59 5.28989 21 3.99989 21H2.99989C2.44989 21 1.99989 21.45 1.99989 22C1.99989 22.55 2.44989 23 2.99989 23H3.99989C5.37989 23 6.73989 22.65 7.99989 22.01C10.5199 23.3 13.4799 23.3 15.9999 22.01C17.2599 22.66 18.6199 23 19.9999 23H20.9999C21.5499 23 21.9999 22.55 21.9999 22C21.9999 21.45 21.5499 21 20.9999 21H19.9999ZM3.94989 19H3.99989C5.41989 19 6.69989 18.3 7.65989 17.36C7.84989 17.18 8.15989 17.18 8.34989 17.36C9.29989 18.3 10.5799 19 11.9999 19C13.4199 19 14.6999 18.3 15.6599 17.36C15.8499 17.17 16.1499 17.17 16.3499 17.36C17.2999 18.3 18.5799 19 19.9999 19H20.0499L21.9399 12.32C22.0199 12.06 21.9999 11.78 21.8799 11.54C21.7599 11.3 21.5399 11.12 21.2799 11.04L19.9999 10.62V6C19.9999 4.9 19.0999 4 17.9999 4H14.9999V2C14.9999 1.45 14.5499 1 13.9999 1H9.99989C9.44989 1 8.99989 1.45 8.99989 2V4H5.99989C4.89989 4 3.99989 4.9 3.99989 6V10.62L2.70989 11.04C2.44989 11.12 2.22989 11.3 2.10989 11.54C1.98989 11.78 1.95989 12.06 2.04989 12.32L3.94989 19ZM6.99989 6H16.9999C17.5499 6 17.9999 6.45 17.9999 7V9.97L12.6199 8.2C12.2099 8.07 11.7799 8.07 11.3699 8.2L5.99989 9.97V7C5.99989 6.45 6.44989 6 6.99989 6Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-directions-boat`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconDirectionsBoat

    ```js
    <b-new-b-icon-directions-boat />
    ```
</docs>


